/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_PublishInputs */

const en_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const es_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

const fr_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier`)
};

const de_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

const ja_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開`)
};

const zh_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布`)
};

const ar_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر`)
};

const id_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan`)
};

const it_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica`)
};

const ru_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать`)
};

const pt_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

const ko_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게시`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Action_PublishInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_publish = /** @type {((inputs?: Action_PublishInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_PublishInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_publish(inputs)
	if (locale === "es") return es_action_publish(inputs)
	if (locale === "fr") return fr_action_publish(inputs)
	if (locale === "de") return de_action_publish(inputs)
	if (locale === "ja") return ja_action_publish(inputs)
	if (locale === "zh") return zh_action_publish(inputs)
	if (locale === "ar") return ar_action_publish(inputs)
	if (locale === "id") return id_action_publish(inputs)
	if (locale === "it") return it_action_publish(inputs)
	if (locale === "ru") return ru_action_publish(inputs)
	if (locale === "pt") return pt_action_publish(inputs)
	return ko_action_publish(inputs)
});